import React, { useState, useEffect, Fragment, } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
// Import your API functions here
import {
  getCompanyByCategoryIdWithPlan,
  getActiveTypeByCompanyId,
  getCompanyByCategoryIdWithPlanNew,
  getMultiProposerCheck,
} from "../../../../api";
import { Row, Col, Card, CardBody, Spinner, Badge, Button, Container } from "reactstrap";
import { bulkPolicy, bulkPolicyReset } from "../../../../redux/bulkPolicy/action";
import BulkDocumentReview from "./bulk-document-review";
import BulkDocumentStepperHeader from "./bulk-document-stepper-header";
import BulkDocumentSuccess from "./bulk-document-success";
import { SALES_MANAGER } from "../../../../constant";

const BulkDocumentTypeAndScheme = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [companyTypes, setCompanyTypes] = useState([]); // schema/company
  const [loading, setLoading] = useState(false);
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);
  const [activeCompany, setActiveCompany] = useState([]);
  const [activeTypes, setActiveTypes] = useState([]);
  const [selectedPolicyType, setSelectedPolicyType] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [isTypeLoading, setIsTypeLoading] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(null);
  const [selectedDocumentVariant, setSelectedDocumentVariant] = useState("");
  const [hasIndividualType, setHasIndividualType] = useState(false);
  const [selectedBulkUpload, setSelectedBulkUpload] = useState("");
  const [currentStep, setCurrentStep] = useState(0); // 0 = form, 1 = review, 2 = success
  const [validationResponse, setValidationResponse] = useState(null);
  const policyData = useSelector((content) => content.bulkPolicy);
  const [isProcessingNext, setIsProcessingNext] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [allowBackNavigation, setAllowBackNavigation] = useState(false);
  const [multiProposerCheck, setMultiProposerCheck] = useState(false);
  
  // Get quotation data from location state (when coming from quotations page)
  const fromQuotation = location?.state?.fromQuotation;
  const quotation_id = location?.state?.quotation_id;
  
  const schema = yup.object().shape({
    company_id: yup.string().required("Company is required"),
    policyType: yup.string().required("Policy type is required"),
    bulkUpload: yup.string().when("policyType", {
      is: (val) => selectedDocumentVariant === "multi" || selectedDocumentVariant === "multi_proposer",
      then: (schema) =>
        schema.required(
          "Bulk Upload selection is required",
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  const {
    handleSubmit,
    register,
    setValue,
    trigger,
    getValues,
    formState: { errors },
    formState,
    reset,
    setError,
    unregister,
    clearErrors,
    control,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    // context: { ped },
    // defaultValues: {},
    mode: "onTouched",
    // context: {
    //     oci,
    //     proposerOCI: proposerOCI.isOci
    // },
    defaultValues: {
      company_id: policyData.generateQuote.company_id || "",
      policyType: policyData.generateQuote.policyType || "",
    },
  });
  //get role
  const ROLE = JSON.parse(localStorage.getItem("ROLE"));
  const role_key = ROLE?.key;
  console.log("Location State:", location.state);
  const user = role_key == "SALES_MANAGER" ? location.state?.user : JSON.parse(localStorage.getItem("user"));
  console.log("User Info:", user);
  
  const balance = role_key == "SALES_MANAGER" ? location.state?.user?.partnerInfo?.wallet_balance : null;
  // Fetch company types
  const fetchCompany = async () => {
    setIsCompanyLoading(true);
    try {
      const res =  role_key == SALES_MANAGER ? await getCompanyByCategoryIdWithPlanNew(1, {partnership_id: user?.partnerInfo?.partnership_id}) :await getCompanyByCategoryIdWithPlan(1);
      // const res = await getCompanyByCategoryIdWithPlan(1);
      console.log("getCompanyByCategoryIdWithPlanNewTEST", res.data.result);

      const data = res.data.result
        .filter(
          (item) =>
            item.Company &&
            item.Company.is_active &&
            item.Company.client_company_alias,
        ) // Ensure 'Company' exists
        .map((item) => ({
          value: item.Company?.company_id,
          client_company_name: item.Company?.client_company_name,
          label: item.Company?.client_company_alias,
          plans: item.Company?.plans || [],
        }));
      console.log(data, "data fetch company");
      setActiveCompany(data);
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to load companies");
      setIsCompanyLoading(false);
    } finally {
      setIsCompanyLoading(false);
    }
  };

  const handleSelection = async (
    policyType,
    documentVariant = null,
    preselectedGeoCoverId = null,
    preselectedCompany = null,
  ) => {
    // console.log(policyType, 'policyType')
    const policyTypeNumber = policyType;
    //   setA2ACountry({ fromcountry: [], tocountry: [] });
    setSelectedPolicyType(policyTypeNumber);
    if (documentVariant) {
      setSelectedDocumentVariant(documentVariant);
    }
    setValue("policyType", policyTypeNumber);
    await trigger("policyType");
    try {
    } catch (err) {}
  };

  const handleTypeSelection = async (
    company_id,
    preselectedPolicyType = null,
    skipReset = false,
  ) => {
    const companyId = company_id;
    setSelectedCompany(companyId);
    setValue("company_id", companyId, { shouldValidate: true });
    trigger("company_id");
    setIsTypeLoading(true);
    
    // Only reset if NOT loading from quotation
    if (!skipReset) {
      // Reset document variant when company changes
      setSelectedDocumentVariant("");
      // Reset bulk upload selection when scheme changes
      setSelectedBulkUpload("");
    }
    // setSelectedPolicyType(null);
    try {
      await HandleMultiProposerCheck();
      const response = await getActiveTypeByCompanyId(companyId);

      setActiveTypes(response.data?.result);

      // Check if there's an "Individual" type in the response
      const individualTypeExists = response.data?.result?.some(
        (t) => t?.type?.title?.toLowerCase() === "individual",
      );
      setHasIndividualType(individualTypeExists);

      if (
        preselectedPolicyType &&
        response.data?.result.find(
          (t) => Number(t.type_id) === Number(preselectedPolicyType),
        )
      ) {
        setValue("policyType", preselectedPolicyType, { shouldValidate: true });
        setSelectedPolicyType(preselectedPolicyType); // optional: for UI highlight
      } else {
        if (!skipReset) {
          setValue("policyType", "");
          setSelectedPolicyType("");
        }
      }
      // await trigger("policyType");
    } catch (err) {
      toast.error(err.response?.data?.error || "Something went wrong");
      setIsTypeLoading(false);
    } finally {
      setIsTypeLoading(false);
    }
  };

  const handleNextClick = async () => {
    if (isProcessingNext) return; // prevent concurrent runs
    setIsProcessingNext(true);

    try {
      const data = getValues();

      // Validate bulkUpload if multi or multi_proposer is selected
      if ((selectedDocumentVariant === "multi" || selectedDocumentVariant === "multi_proposer") && !selectedBulkUpload) {
        toast.error("Please select Bulk Upload option");
        setIsProcessingNext(false);
        return;
      }

      if (selectedDocumentVariant === "multi_proposer" && selectedBulkUpload === "yes") {
        if (role_key === SALES_MANAGER) {
          navigate("/sales/policies/bulk", {
            state: { user: location.state?.user, company_id: selectedCompany },
          });
        } else {
          navigate("/sales/policies/bulk", {
            state: { company_id: selectedCompany },
          });
        }
        setIsProcessingNext(false);
        return;
      }

      // Update Redux with complete data

      const completePayload = {
        generateQuote: {
          company_id: selectedCompany,
          policyType: selectedPolicyType,
          documentVariant: selectedDocumentVariant,
          bulkUpload: selectedBulkUpload,
        },
      };

      dispatch(bulkPolicy(completePayload));

      console.log("Saved Bulk Policy Data:", completePayload);

      // Move to next step (review screen)
      setCurrentStep(1);
    } catch (err) {
      console.error("Error on Next Click:", err);
      toast.error("An error occurred. Please try again.");
    } finally {
      setIsProcessingNext(false);
    }
  };

  const HandleMultiProposerCheck = async () => {
    try {
      const response = await getMultiProposerCheck();
      console.log(response, "HandleMultiProposerCheck response");
      setMultiProposerCheck(response?.data?.result);
    } catch (error) {
      console.error("Error in HandleMultiProposerCheck:", error);
    }
  }

  const handleBackClick = () => {
    setAllowBackNavigation(true);
    setCurrentStep(0);
  };

  

  // Load saved data from Redux when editing a quotation
  // This runs AFTER BulkDocumentReview has loaded the data into Redux
  useEffect(() => {
    // Only run if we're coming from quotation AND we're still on step 0 (form screen)
    // AND Redux has been populated with data
    if (fromQuotation && currentStep === 0 && policyData?.companyId && policyData?.typeId && activeCompany.length > 0) {
      console.log("🔍 Pre-filling form with saved bulk quotation data:", policyData);
      
      // Set company and fetch types (pass true to skip reset)
      if (policyData.companyId) {
        setSelectedCompany(policyData.companyId);
        setValue("company_id", policyData.companyId);
        
        // Fetch types for this company but don't reset selections
        handleTypeSelection(policyData.companyId, policyData.typeId, true);
      }
      
      // Set policy type
      if (policyData.typeId) {
        setSelectedPolicyType(policyData.typeId);
        setValue("policyType", policyData.typeId);
      }
      
      // Set document variant (single/multi)
      if (policyData.documentVariant) {
        setSelectedDocumentVariant(policyData.documentVariant);
      }
      
      // Set bulk upload (yes/no)
      if (policyData.generateQuote?.bulkUpload) {
        setSelectedBulkUpload(policyData.generateQuote.bulkUpload);
      }
    }
  }, [fromQuotation, currentStep, policyData?.companyId, policyData?.typeId, policyData?.documentVariant, policyData?.generateQuote?.bulkUpload, activeCompany.length]);

  // Auto-advance to review step when data is loaded from quotation
  // BUT only if user hasn't explicitly clicked Back button
  useEffect(() => {
    if (fromQuotation && policyData?.validationData?.successLog?.length > 0 && currentStep === 0 && !allowBackNavigation) {
      console.log("✅ Data loaded from quotation, moving to review step");
      setCurrentStep(1);
    }
    
    // Mark that initial data load is complete
    if (fromQuotation && policyData?.companyId && policyData?.typeId && !initialLoadComplete) {
      console.log("✅ Initial quotation data loaded into Redux");
      setInitialLoadComplete(true);
    }
  }, [fromQuotation, policyData?.validationData?.successLog, policyData?.companyId, policyData?.typeId, currentStep, initialLoadComplete, allowBackNavigation]);

  // Clear Redux state when component mounts (starting new bulk upload) - but NOT when editing
  useEffect(() => {
    if (!fromQuotation) {
      console.log("🔄 Starting new bulk upload - Clearing previous Redux state");
      dispatch(bulkPolicyReset());
      // Start at step 0 for new uploads
      setCurrentStep(0);
    } else {
      // If coming from quotation, also start at step 0 but don't clear Redux
      console.log("📋 Coming from quotation - Starting at step 0 (form) with data loading in background");
      setCurrentStep(0);
      setAllowBackNavigation(true); // Prevent auto-navigation to step 1
    }
    fetchCompany();
  }, [dispatch, fromQuotation]);

  const steps = [
    { name: "Select Scheme & Type" },
    { name: "Review & Upload" },
    { name: "Proposer Details" },
    { name: "Payment" },
  ];

  return (
    <>
      <Card style={{ marginTop: "0px" }}>
        <CardBody className="btn-group-showcase">
          {/* Stepper Header - Moved inside the Card */}
          <BulkDocumentStepperHeader currentStep={currentStep === 2 ? 1 : currentStep} steps={steps} user={user} />

          {/* STEP 0: Form Screen - Scheme/Type/Bulk Upload Selection */}
          {currentStep === 0 && (
          <Row style={{ marginTop: "20px" }}>
            <Col xl="9" sm="9" style={{ paddingLeft: "0px" }}>
              <h6 className="mb-0" style={{ fontSize: "13px" }}>
                <b>{"Select Scheme"}</b>
              </h6>
            </Col>
            <Col xl="9" sm="9" style={{ paddingLeft: "0px" }}>
              <input type="hidden" {...register("company_id")} />
            </Col>

            <Col xl="9" sm="9" style={{ paddingLeft: "0px" }}>
              <div className="d-flex flex-nowrap">
                {isCompanyLoading ? (
                  <div className="no-types-message">
                    <span style={{ fontSize: "12px" }}>Fetching available schemes...</span>
                  </div>
                ) : activeCompany.length ? (
                  activeCompany
                    .sort((a, b) => a.value - b.value)
                    .map((company) => (
                      <div
                        key={company.value}
                        style={{ position: "relative", marginRight: "15px" }}
                      >
                        <Button
                          id={`company-${company.value}`}
                          size="lg"
                          color="primary"
                          name="company_id"
                          className={`policyButton ${Number(selectedCompany) === Number(company.value) ? "selected" : ""}`}
                          onClick={() => handleTypeSelection(company.value)}
                          style={{
                            width: "180px",
                            height: "-webkit-fill-available",
                            fontSize: "12px",
                            padding: "8px 12px",
                          }}
                          onMouseEnter={() => setTooltipOpen(company.value)}
                          onMouseLeave={() => setTooltipOpen(null)}
                          aria-describedby={`tooltip-${company.value}`}
                        >
                          {company.label}
                        </Button>
                        {/* Custom styled tooltip */}
                        <span
                          id={`tooltip-${company.value}`}
                          style={{
                            visibility:
                              tooltipOpen === company.value
                                ? "visible"
                                : "hidden",
                            opacity: tooltipOpen === company.value ? 1 : 0,
                            transition: "opacity 0.18s",
                            position: "absolute",
                            top: "100%",
                            left: "10px",
                            background: "#00239c",
                            color: "#fff",
                            borderRadius: "6px",
                            padding: "6px 12px",
                            zIndex: 1000,
                            minWidth: "100px",
                            maxWidth: "180px",
                            fontSize: "11px",
                            pointerEvents: "none",
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.12)",
                            whiteSpace: "pre-line",
                            fontFamily: "Poppins, sans-serif",
                            lineHeight: 1.4,
                          }}
                          role="tooltip"
                        >
                          {company.client_company_name ? (
                            <ul
                              style={{
                                margin: 0,
                                padding: 0,
                                listStyleType: "none",
                                textAlign: "start",
                              }}
                            >
                              <li
                                className="schemeListCss"
                                style={{ marginTop: "2px", fontSize: "11px" }}
                              >
                                - {company.client_company_name}
                              </li>
                            </ul>
                          ) : (
                            <span style={{ fontSize: "11px" }}>
                              No plans available
                            </span>
                          )}
                        </span>
                      </div>
                    ))
                ) : (
                  <div className="no-types-message">
                    <span style={{ fontSize: "12px" }}>No Plans available, Please contact HO</span>
                  </div>
                )}
              </div>
              {errors.company_id && (
                <p className="text-danger" style={{ paddingLeft: "15px", fontSize: "12px", marginTop: "6px" }}>
                  {errors.company_id.message}
                </p>
              )}
            </Col>
            {selectedCompany && (
              <Col
                xl="9"
                sm="9"
                style={{ paddingLeft: "0px", marginTop: "18px" }}
              >
                <h6 className="mb-0" style={{ fontSize: "13px" }}>
                  <b>{"Type of Document"}</b>
                </h6>
              </Col>
            )}
            {selectedCompany && (
              <Col xl="9" sm="9" style={{ paddingLeft: "0px" }}>
                <div className="d-flex flex-nowrap">
                  {isTypeLoading ? (
                    <div className="no-types-message">
                      <span style={{ fontSize: "12px" }}>Fetching types...</span>
                    </div>
                  ) : hasIndividualType &&
                    activeTypes &&
                    activeTypes.length > 0 ? (
                    // Show Single and Multi Individual buttons
                    activeTypes
                      .filter(
                        (type) =>
                          type?.type?.title?.toLowerCase() === "individual",
                      )
                      .map((individualType) => (
                        <Fragment
                          key={`individual-${individualType?.type?.id}`}
                        >
                          {/* <Button
                            size="md"
                            color="primary"
                            name="policyType"
                            className={`policyButton ${
                              Number(selectedPolicyType) ===
                                Number(individualType?.type?.id) &&
                              selectedDocumentVariant === "single"
                                ? "selected"
                                : ""
                            }`}
                            {...register("policyType")}
                            defaultValue={
                              selectedPolicyType
                                ? selectedPolicyType
                                : getValues()["policyType"]
                            }
                            onClick={() =>
                              handleSelection(
                                individualType?.type?.id,
                                "single",
                              )
                            }
                            style={{ marginRight: "10px", fontSize: "12px", padding: "8px 12px" }}
                          >
                            Single Individual
                          </Button> */}
                          <Button
                            size="md"
                            color="primary"
                            name="policyType"
                            className={`policyButton ${
                              Number(selectedPolicyType) ===
                                Number(individualType?.type?.id) &&
                              (selectedDocumentVariant === "multi" || selectedDocumentVariant === "multi_proposer")
                                ? "selected"
                                : ""
                            }`}
                            {...register("policyType")}
                            defaultValue={
                              selectedPolicyType
                                ? selectedPolicyType
                                : getValues()["policyType"]
                            }
                            onClick={() =>
                              handleSelection(individualType?.type?.id, "multi")
                            }
                            style={{ fontSize: "12px", padding: "8px 12px" }}
                          >
                            Multi Individual
                          </Button>
                        </Fragment>
                      ))
                  ) : null}
                </div>
                {errors.policyType && (
                  <p className="text-danger" style={{ paddingLeft: "15px", fontSize: "12px", marginTop: "6px" }}>
                    {errors.policyType.message}
                  </p>
                )}
              </Col>
            )}
            {selectedCompany && (selectedDocumentVariant === "multi" || selectedDocumentVariant === "multi_proposer") && (
              <Col
                xl="9"
                sm="9"
                style={{ paddingLeft: "0px", marginTop: "18px" }}
              >
                <h6 className="mb-0" style={{ fontSize: "13px" }}>
                  <b>{"Bulk Upload"}</b>
                </h6>
              </Col>
            )}
            {selectedCompany && (selectedDocumentVariant === "multi" || selectedDocumentVariant === "multi_proposer") && (
              <Col xl="9" sm="9" style={{ paddingLeft: "0px" }}>
                <div className="d-flex flex-nowrap">
                  <Button
                    size="md"
                    color="primary"
                    name="bulkUpload"
                    className={`policyButton ${
                      selectedBulkUpload === "yes" && selectedDocumentVariant === "multi" ? "selected" : ""
                    }`}
                    onClick={() => {
                      setSelectedBulkUpload("yes");
                      setSelectedDocumentVariant("multi");
                    }}
                    style={{ marginRight: "10px", fontSize: "12px", padding: "8px 12px" }}
                  >
                    Single Proposer
                  </Button>
                    {multiProposerCheck && (
                      <Button
                        size="md"
                        color="primary"
                        name="bulkUpload"
                        className={`policyButton ${selectedBulkUpload === "yes" && selectedDocumentVariant === "multi_proposer" ? "selected" : ""
                          }`}
                        onClick={() => {
                          setSelectedBulkUpload("yes");
                          setSelectedDocumentVariant("multi_proposer");
                        }}
                        style={{ fontSize: "12px", padding: "8px 12px" }}
                      >
                        Multi Proposer
                      </Button>)}
                  {/* <Button
                    size="md"
                    color="primary"
                    name="bulkUpload"
                    className={`policyButton ${
                      selectedBulkUpload === "yes" && selectedDocumentVariant === "multi_proposer" ? "selected" : ""
                    }`}
                    onClick={() => {
                      setSelectedBulkUpload("yes");
                      setSelectedDocumentVariant("multi_proposer");
                    }}
                    style={{ fontSize: "12px", padding: "8px 12px" }}
                  >
                    Multi Proposer
                  </Button> */}
                  {/* <Button
                    size="md"
                    color="primary"
                    name="bulkUpload"
                    className={`policyButton ${
                      selectedBulkUpload === "no" ? "selected" : ""
                    }`}
                    onClick={() => setSelectedBulkUpload("no")}
                    style={{ fontSize: "12px", padding: "8px 12px" }}
                  >
                    No
                  </Button> */}
                </div>
              </Col>
            )}

            <div className="d-flex justify-content-end btn-mt">
              <Button
                color="primary"
                className="rounded-pill stepper-next-btn"
                onClick={async () => {
                  const isValid = await trigger(["company_id", "policyType"]);
                  if (isValid) {
                    handleNextClick();
                  }
                }}
                disabled={isProcessingNext}
                style={{ padding: "6px 18px", fontSize: "12px" }}
              >
                {isProcessingNext ? <Spinner size="sm" /> : null} Next{" "}
                <span className="ml-2">{">"}</span>
              </Button>
            </div>
          </Row>
          )}

          {/* STEP 1: Review Screen - Data Display and Confirmation */}
          {currentStep === 1 && (
          <BulkDocumentReview
            activeCompany={activeCompany}
            handleBackClick={handleBackClick}
            fromQuotation={fromQuotation}
            quotation_id={quotation_id}
            userData={user}
            balance={balance}
            onValidationSuccess={(response) => {
              setValidationResponse(response);
              setCurrentStep(2);
            }}
          />
        )}
        
          {/* Hidden component to load quotation data in background when coming from quotation */}
          {fromQuotation && currentStep === 0 && (
            <div style={{ display: 'none' }}>
              <BulkDocumentReview
                activeCompany={activeCompany}
                handleBackClick={handleBackClick}
                fromQuotation={fromQuotation}
                quotation_id={quotation_id}
                userData={user}
                onValidationSuccess={(response) => {
                  // Don't navigate, just load data
                }}
              />
            </div>
          )}

          {/* STEP 2: Success Screen - Confirm & Pay */}
          {currentStep === 2 && (
          <BulkDocumentSuccess
            validationData={validationResponse}
            handleBackClick={() => {
              setCurrentStep(1);
              setValidationResponse(null);
            }}
          />
        )}
      </CardBody>
    </Card>
    </>
  );
};

export default BulkDocumentTypeAndScheme;
